export default __webpack_public_path__ + "static/media/grade-gold.95b95819.svg";